function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function l(t) {
  if (_typeof(t) != "object" || t == null) return !1;
  if (Object.getPrototypeOf(t) === null) return !0;
  if (Object.prototype.toString.call(t) !== "[object Object]") {
    var _Object$getOwnPropert;
    var r = t[Symbol.toStringTag];
    return r == null || !((_Object$getOwnPropert = Object.getOwnPropertyDescriptor(t, Symbol.toStringTag)) !== null && _Object$getOwnPropert !== void 0 && _Object$getOwnPropert.writable) ? !1 : t.toString() === "[object ".concat(r, "]");
  }
  var e = t;
  for (; Object.getPrototypeOf(e) !== null;) e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
}
export { l as isPlainObject };